import {API_URL} from '../../../request'

export const listContactUrl = () => {
    return API_URL + `/contact/list`
}
